import ScrollToPlugin from 'gsap/ScrollToPlugin';

document.addEventListener('DOMContentLoaded',function() {

    const btnGoTo = document.getElementsByClassName('js-goto'),
          topbar = document.getElementsByClassName('js-top')[0];

	const speed_calculate = function (target) {
    	let base_speed  = 60,
    		page_offset = window.pageYOffset || document.documentElement.scrollTop,
        	offset_diff = Math.abs(target - page_offset),
        	speed = ((offset_diff * base_speed) / 1000)/100;

    	return speed;
	};
	
	const clickAction = function(e) {
	
	e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
	
	    const that = e.currentTarget;

	    let src = that.getAttribute('href'),
	        offset = that.getAttribute('data-offset');
	    
	    const moveTo = function() {
		    const window_pos = window.pageYOffset || window.scrollY || document.documentElement.scrollTop;
	
		    const obj = document.getElementById(src.slice(1, src.length));
	
		    if (obj) {
			    
			    if (offset) {

			    } else {
    			    
    			    offset = 0;

                    if (obj.classList.contains('c-steps__item')) {
                        offset = -100;
                    }
			    }
			    
		        
		        //console.log(obj);
	            
	            //document.body.removeAttribute('style');
		    
		        let target = window_pos + obj.getBoundingClientRect().top;
		        cutme.Helpers.scrollTo(target, speed_calculate(target), offset);
		        
		        //topbar.classList.add('is-out');
	
		    } else {
	    	    
	    	    window.open(src, '_self');
	    	    
		    }
	    };


	    if (!src) {
	    	
	        src = that.getElementsByTagName('a')[0].getAttribute('href');
	    }
	        
        // Check if current page is the same of the link
        
       /*
 if ( src.split('#')[0] ===  window.location.pathname.slice(1)) {

			// Get only hash
					        
			let hash = src.split('#')[1];

			if (hash) {
				src = "#" + hash;
			}
			
			console.clear();
			console.log('has');
        }
*/
        

        
        
        const getLocation = function(href) {
            var l = document.createElement("a");
            l.href = href;
            return l;
        };


    	
    	
    	let link = getLocation(src);

        console.clear();     	
    	console.log( 'path name: ' + window.location.pathname);
    	console.log( 'url: ' +  link.pathname );
        
        
        
        // check if anchor is on the same page
        
        if (window.location.pathname === link.pathname) {
            
            console.log('simple');
            
            let hash = src.split('#')[1];

			if (hash) {
				src = "#" + hash;
			}
			
			moveTo();
            
        } else {
            
            console.log('reload');
            
            window.open(src, '_self');
        }
	    
	};
	


    if (btnGoTo.length > 0) {
        for (let i = 0; i < btnGoTo.length; i++) {
            btnGoTo[i].addEventListener('click', clickAction);
        }
    }

    
}, false);
